// frontend/src/lib/bannerInset.ts
//
// The "newer Ads IQ" banner's height while it shows, published by UpdateNotice as a CSS variable on <html> ("0px"
// otherwise). Every scroller the banner can cover reserves it: its bottom padding reads the variable, and — live
// QA on v2-eca6d827 at 390 — so does its scroll-padding, because the browser's own focus-scrolling ignores padding
// and put a focused field under the banner.
export const UPDATE_BANNER_INSET_VAR = "--update-banner-inset";

/** scroll-padding-bottom for a scroller the banner can cover: focus / scrollIntoView stops above the banner. */
export const BANNER_SCROLL_PADDING = { scrollPaddingBottom: `var(${UPDATE_BANNER_INSET_VAR}, 0px)` } as const;
